<div class="h-100 d-flex flex-column overflow-hidden">
    <div class="px-sm-4 pt-3">
        <dx-tabs
            keyExpr="id"
            [items]="tabs"
            [selectedItemKeys]="selectedTabKeys"
            [showNavButtons]="false"
            stylingMode="primary"
            (onItemClick)="onTabClick($event.itemData.id)"
        ></dx-tabs>
    </div>
    <div class="flex-grow-1 overflow-hidden">
        @if (selectedTabKeys[0] === 'line') {
            <app-order-lines></app-order-lines>
        } @else if (selectedTabKeys[0] === 'load') {
            <app-load-level></app-load-level>
        } @else {
            <app-orders-header></app-orders-header>
        }
    </div>
</div>
